import React from "react";
import { Badge, Card, Group, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { useTabNavigate } from "../../hooks/useTabNavigate";

const MigrationProviderCard = ({ provider }) => {
  const tabNav = useTabNavigate();
  const isActive = provider.status === "active";

  const handleClick = () => {
    if (!isActive || !provider.path) return;
    tabNav.open({ pathname: `/management/dataMigration/${provider.path}` });
  };

  return (
    <Card
      withBorder
      padding="lg"
      radius="md"
      onClick={handleClick}
      sx={(theme) => ({
        cursor: isActive ? "pointer" : "not-allowed",
        opacity: isActive ? 1 : 0.55,
        transition: "border-color 150ms ease, transform 150ms ease",
        "&:hover": isActive
          ? {
              borderColor: theme.colors.teal[6],
              transform: "translateY(-2px)",
            }
          : undefined,
      })}
    >
      <Stack spacing="sm">
        <Group position="apart" align="flex-start" noWrap>
          <ThemeIcon size={42} radius="md" variant="light" color={isActive ? "teal" : "gray"}>
            <provider.icon size={22} />
          </ThemeIcon>
          {!isActive && (
            <Badge color="gray" variant="outline" size="sm">
              Coming soon
            </Badge>
          )}
        </Group>
        <Title order={5}>{provider.name}</Title>
        {provider.description && (
          <Text size="sm" color="dimmed" lineClamp={3}>
            {provider.description}
          </Text>
        )}
      </Stack>
    </Card>
  );
};

export default MigrationProviderCard;
